// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
export const firebaseConfig = {
  apiKey: "AIzaSyDaj2yyd9V1ZewtTzi0HzJMqF18iD2cZe8",
  authDomain: "create-dwell.firebaseapp.com",
  projectId: "create-dwell",
  storageBucket: "create-dwell.appspot.com",
  messagingSenderId: "455762932168",
  appId: "1:455762932168:web:cefc0f7470159c6f1ad0fd",
  measurementId: "G-E5G32KQR13"
};
